/* Component Dependencies */
var overlayTitleTemplate = require('templates/overlayTitle.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'overlayTitle',
  template: {
    'overlayTitle': overlayTitleTemplate
  }
});
